import { FC } from 'react'

import { getTaskTypeLabel } from './getTaskTypeLabel'

export interface TaskTypeLabelProps {
  name: string
}

export const TaskTypeLabel: FC<TaskTypeLabelProps> = ({ name }) => <span>{getTaskTypeLabel(name)}</span>
